import React from "react";
import { memo } from "react";
import TagsInput from "react-tagsinput";

class TagsInputs extends React.PureComponent {
  constructor() {
    super();
    this.tagsinput = React.createRef();
    this.state = {
      tags: [],
      tag: "",
    };
  }
  handleChange = (tags) => {
    this.setState({ tags });
  };
  handleInputChange = (value) => {
    if (value.length > 8) {
      return this.tagsinput.current.accept();
    }
    this.setState({ tag: value });
  };
  render() {
    return (
      <TagsInput
        onlyUnique
        ref={this.tagsinput}
        inputProps={{
          placeholder: "Add People",
        }}
        value={this.state.tags}
        onChange={this.handleChange}
        inputValue={this.state.tag}
        onChangeInput={this.handleInputChange}
        className="border border-color border-radius-4 pl-2 pt-1"
      />
    );
  }
}

export default memo(TagsInputs);
